<template lang="pug">
form-item-wrapper(v-bind="bind", :rules="rules", :class="formItemClass")
  .empty(v-if="designState") 动态加载{{ contentKey }}界面
  div(v-loading="loading", v-else, :style="containerCss")
    quill-editor(v-model="html", :options="editorOption", disabled)
</template>
<script>
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import { staticMixins } from "@/CommonDP/VForm/utils";
import { pub_rich_content_details } from "@/CommonDP/service/rich-text-service";
export default {
  components: { quillEditor },
  mixins: [staticMixins],
  data() {
    return {
      html: "",
      loading: false,
      editorOption: {
        placeholder: "暂无数据",
        theme: "snow",
        readOnly: true,
        modules: {
          toolbar: []
        }
      }
    };
  },
  computed: {
    contentKey() {
      return this.options.contentKey;
    },
    containerCss() {
      const {
        options: { maxHeight }
      } = this;
      const css = { overflowY: "auto" };
      if (maxHeight) css.maxHeight = maxHeight + "px";
      return css;
    }
  },
  created() {
    this.getWebCode();
  },
  methods: {
    async getWebCode() {
      const { contentKey } = this;
      if (!contentKey) return;
      if (this.designState) return;
      try {
        this.loading = true;
        const {
          data: { content }
        } = await pub_rich_content_details({ contentKey });
        this.customEvent('onLoad', content);
        this.html = content;
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.empty {
  user-select: none;
  color: #bbb;
  text-align: center;
  background-color: #f5f5f5;
  height: 30px;
}
.quill-editor /deep/ {
  .ql-toolbar {
    display: none;
  }
  .ql-container {
    border: 0;
  }
}
</style>
